/*
 * @Description: 
 * @FilePath: \京东互动积分B端\src\api\userInform.js
 */
import {
  post,
  postJson,
  get,
  put
} from './axios'

const RESOURCE_BASE_PATH = '/seller';

//获取当前登录账号信息
export const querySellerSetting = p => get(`${RESOURCE_BASE_PATH}/current`, p);

export const queryJhkSeller = p => get(`${RESOURCE_BASE_PATH}/current`, p);

//更新当前登录账号信息
export const updateSellerSetting = p => put(`${RESOURCE_BASE_PATH}/accountSetting`, p);


// 获取验证码
export const checkCodeSet = p => get(`${RESOURCE_BASE_PATH}/checkCode`, p);